import type { FinisherCertificate } from '@fastnorth/timer-api';
import { gql } from '@apollo/client';
import type { TemplateSponsorLogo } from '../../../../../../../graphql/rest-link/types.ts';

export const GET_FINISHER_CERTIFICATE_BY_ID = gql`
  query getCertificate($eventUniqueCode: ID!, $certificateId: ID!) {
    getCertificate(eventUniqueCode: $eventUniqueCode, certificateId: $certificateId)
      @rest(
        type: "FinisherCertificateResponse"
        path: "/v2/api/events/{args.eventUniqueCode}/finisher-certificate/{args.certificateId}"
        method: "GET"
      ) {
      id
      backgroundImageId
      backgroundImageUrl
      resultEventId
      applyToAllSubEvents
      isHidden
      subEvents
      isAdvancedCustomizationEnabled
      content
      border
      bodyText
      headerText
      bodyBackground
      headerBackground
      sponsorLogoHeight
      useBackgroundImage
      backgroundImageStyle
      isProviderLogoVisible
      isEventLogoVisible
      isEventNameVisible
      isEventDateVisible
      isPlaceVisibleBeforeRaceEnded
      areSponsorLogosEnabled
    }
  }
`;

export type GetFinisherCertificateByIdVariables = {
  certificateId: string;
  eventUniqueCode: string;
};

export type GetFinisherCertificateByIdData = {
  getCertificate: FinisherCertificate;
};

export const GET_EVENT_TEMPLATE_CONTENT_BY_ID = gql`
  query getEventTemplateContentById($eventUniqueCode: ID!, $id: ID!) {
    getEventTemplateContentById(eventUniqueCode: $eventUniqueCode, id: $id)
      @rest(
        type: "EventTemplateContentResponse"
        path: "/v2/api/events/{args.eventUniqueCode}/event-template-content/{args.id}"
        method: "GET"
      ) {
      id
      kind
      isEnabled
      isAppliedToAllSubEvents
      appliesToSubEvents
      jsonContent
      htmlContent
      isLocked
      createdAt
      createdBy
      lastModifiedAt
      lastModifiedBy
      sponsorLogos
      sponsorLogoHeight
    }
  }
`;

export type GetEventTemplateContentByIdVariables = {
  eventUniqueCode: string;
  id: string;
};

export type EventTemplateContent = {
  id: string;
  kind: 'finisher_certificate' | 'race_poster';
  isEnabled: boolean;
  isAppliedToAllSubEvents: boolean;
  appliesToSubEvents: number[] | null;
  jsonContent: Record<string, unknown>;
  htmlContent: string;
  isLocked: boolean;
  createdAt: string;
  createdBy: number;
  lastModifiedAt: string | null;
  lastModifiedBy: number | null;
  sponsorLogos?: TemplateSponsorLogo[];
  sponsorLogoHeight?: number;
};

export type GetEventTemplateContentByIdData = {
  getEventTemplateContentById: EventTemplateContent;
};
